<template>
  <div id="layout-wrapper">
    <NavBar :title="page" @onSubmit="$emit('submit', $event)"/>
    <div class="container-fluid">
      <div class="layout-content" >
        <slot/>
      </div>
    </div>

    <Loading v-if="isLoading" />
  </div>
</template>

<script>
import NavBar from '@/components/nav-item'
import { mapState } from "vuex";
export default {
  name: 'layoutItem',

  props: {
    page: {
      value: String,
      default: ''
    }
  },

  components: {
    NavBar
  },

  data() {
    return {
      onSubmit: false
    }
  },

  computed: {
  ...mapState("item", {
    isLoading: state => state.isLoading
  })
  },
}
</script>

<style lang="scss" scoped>
.layout-content {
  margin: 132px auto 60px;
}
</style>